export default {
  helloworld(state) {
    return state.helloworld;
  },
};
